import React from "react";
import { STAGES, STAGE_TONES } from "../config/stages";

const DetailHeader = function (props) {
  const {
    reference,
    ticketNumber,
    stage,
    outcome,
    onBack,
    onAdvance,
    onRevert,
    atStart,
    atEnd,
    canAdvance,
    pendingApproval,
    canApprove,
    onApprove,
    busy,
  } = props;

  /*
  While the ticket is pending approval, Advance stage approves the ticket
  (onApprove) instead of stepping the status, as in
  Warranties/SingleWarranty/TicketProcess.js. Decline (DeclineTicketModal in
  ApprovalModals.js) is out of scope for now, so Revert stays in its place.
  */
  let actions = null;
  if (pendingApproval) {
    actions = canApprove ? (
      <React.Fragment>
        <button type="button" className="tn-btn tn-btn-ghost" onClick={onRevert} disabled={atStart}>
          &larr; Revert
        </button>
        <button type="button" className="tn-btn tn-btn-primary" onClick={onApprove} disabled={busy}>
          Advance stage &rarr;
        </button>
      </React.Fragment>
    ) : (
      <span className="tn-header-note">Awaiting approval</span>
    );
  } else if (canAdvance) {
    actions = (
      <React.Fragment>
        <button type="button" className="tn-btn tn-btn-ghost" onClick={onRevert} disabled={atStart}>
          &larr; Revert
        </button>
        <button type="button" className="tn-btn tn-btn-primary" onClick={onAdvance} disabled={atEnd}>
          Advance stage &rarr;
        </button>
      </React.Fragment>
    );
  }

  const current = STAGES[stage];
  const tone = (current && STAGE_TONES[current.key]) || {
    bg: "#eef0f3",
    fg: "#64748b",
  };
  const isComplete = current && current.key === "complete";
  const badgeLabel =
    isComplete && outcome ? "Complete · " + outcome : current.label;

  return (
    <div className="tn-detail-header">
      <button type="button" className="tn-backlink" onClick={onBack}>
        &larr; All cases
      </button>

      <div className="tn-detail-titlerow">
        <div className="tn-header-identity">
          <span className="tn-logo" aria-hidden="true">
            S
          </span>
          <div>
            <h1 className="tn-header-title">
              RMA Portal <span className="tn-header-title-muted">/ Case</span>
            </h1>
            <p className="tn-header-subtitle tn-mono">
              {ticketNumber || reference}
            </p>
          </div>
        </div>

        <div className="tn-header-actions">
          <span
            className="tn-badge tn-badge-dot tn-badge-lg"
            style={{ background: tone.bg, color: tone.fg }}
          >
            <span className="tn-badge-dotmark" />
            {badgeLabel}
          </span>
          {actions}
        </div>
      </div>
    </div>
  );
};

export default DetailHeader;
